import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfigColumnDef } from './config-table.component';

export interface ConfigAddDialogData {
  tableName: string;
  columns: ConfigColumnDef[];
}

@Component({
  selector: 'app-config-add-dialog',
  templateUrl: './config-add-dialog.component.html',
  styles: [`
    .full-width { width: 100%; }
    .dialog-field { margin-bottom: 4px; }
    .boolean-field { padding: 8px 0 16px; }
  `],
})
export class ConfigAddDialogComponent {
  row: Record<string, any> = {};

  constructor(
    public dialogRef: MatDialogRef<ConfigAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfigAddDialogData,
  ) {}

  get editableColumns(): ConfigColumnDef[] {
    return this.data.columns.filter(c => c.editable !== false);
  }

  isValid(): boolean {
    return this.editableColumns
      .filter(c => c.required)
      .every(c => {
        const v = this.row[c.field];
        return v != null && v !== '' && (typeof v !== 'number' || !isNaN(v));
      });
  }

  save(): void {
    if (!this.isValid()) return;
    this.dialogRef.close(this.row);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
